import { STORAGE_BASE_URL } from 'constants/index'

export const getPublicUrl = path =>
  [STORAGE_BASE_URL.replace(/\/$/, ''), encodeURIComponent(path.replace(/^\//, ''))].join('/')
